import React from "react"
import { ResultRowShell } from "./result_row_shell"
import { CategoryIcon } from "../category_icon"
import { librarySubtypeLabel } from "./library_subtype_label"
import type { SearchRowComponent } from "./types"

// A library resource (book, podcast, movie, …). Shows a subtle kind pill derived from the __typename so
// the many Item subtypes stay distinguishable in one list.
export const LibraryRow: SearchRowComponent = ({ hit, position, onSelect }) => (
  <ResultRowShell hit={hit} position={position} onSelect={onSelect}>
    <CategoryIcon category="Library" className="shrink-0 text-secondary-400" />
    <span className="truncate">{hit.name}</span>
    <span className="ml-auto shrink-0 rounded bg-secondary-100 px-1.5 py-0.5 text-xs text-secondary-500">
      {librarySubtypeLabel(hit.__typename)}
    </span>
  </ResultRowShell>
)
